import { Outlet } from 'react-router';
import { useAktivIroda } from '../iroda/AktivIroda.tsx';
import NincsOldal from '../oldalak/NincsOldal.tsx';

/** A super útvonalak kapuja. A jogot az adatbázis kényszeríti ki; ez csak a felületet rejti el. */
export default function SuperKapu() {
  const { jogok } = useAktivIroda();
  return jogok.super ? <Outlet /> : <NincsOldal />;
}
